<template>
  <section class="follow-container"
           v-if="show">
    <transition name="toBottom">
      <section class="main flex-r ms"
               v-if="!isScroll">
        <section class="left flex-r">
          <template v-if="owner.type === 'user'">
            <section class="avatar"
                     :style="{backgroundImage: `url(${owner.avatar})`}"></section>
            <section class="wrapper flex-c">
              <p class="name">{{ owner.nickname }}</p>
              <p class="info">订阅我，开启活动推送</p>
            </section>
          </template>
          <template v-else>
            <section class="avatar"
                     :style="{backgroundImage: `url(${owner.logo})`}"></section>
            <section class="wrapper flex-c">
              <p class="name">{{ owner.name }}</p>
              <p class="info">订阅我，开启活动推送</p>
            </section>
          </template>
        </section>
        <section class="right">
          <div class="btn"
               v-if="!followed">
            + 订阅
            <div class="wx-link"
                 v-html="linkToWeapp"></div>
          </div>
          <div class="btn followed"
               v-else>
            已订阅
          </div>
        </section>
      </section>
    </transition>
  </section>
</template>
<script>
import Api from '@/Api.js'
/* eslint-disable */
export default {
  /******************************************
  ** 关注主办方模块
  * @description 关注主办方
  * @author stone
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'x_follow',
  components: {},
  props: {},
  data () {
    return {
      followed: false,
      owner: {},
      agent: {},
      liveInfo: {},
      isScroll: false,
      show: true
    }
  },
  computed: {
    liveId () {
      return this.$store.state.page.followInfo.linkId
    },
    liveCount () {
      const u = this.owner.apparentAggregate
      if (u) {
        return u.activityItems + u.liveAlbums + u.liveVideos
      } else {
        return 0
      }
    },
    followCount () {
      const u = this.owner.apparentAggregate
      if (u) {
        return u.followers
      } else {
        return 0
      }
    },
    linkToWeapp () {
      return `<wx-open-launch-weapp
        class="openweapp"
        username="gh_49eacc118770"
        path="PackageActivity/organizer/organizer?isTeam=${this.owner.type === 'team'}&id=${this.owner.id}&serviceManagerId=${this.agent.id}&from=h5">
        <script type="text/wxtag-template">
          <style>.btn{
                      width: 9999px;
                      height: 9999px;
                      }</style>
          <button class="btn">
        </button>
      <\/script>
      </wx-open-launch-weapp>`;
    }
  },
  methods: {
    listenScroll () {
      let firstHeight = window.pageYOffset
      let nowHeight = 0
      window.addEventListener('scroll', () => {
        nowHeight = window.pageYOffset
      }, false)
      setInterval(() => {
        if (nowHeight !== firstHeight) {
          this.isScroll = true
          firstHeight = nowHeight
        } else {
          this.isScroll = false
        }
      }, 100)
    },
    async initData () {
      if (this.liveId) {
        try {
          this.liveInfo = (await Api.getLiveInfo(this.liveId)).data
          if (this.liveInfo.userId) {
            // 个人
            this.owner = (await Api.getUserInfo(this.liveInfo.userId)).data
            this.owner.type = 'user'
          } else {
            // 团队
            this.owner = (await Api.getTeamInfo(this.liveInfo.teamId)).data
            this.owner.type = 'team'
          }
          const { agent } = this.liveInfo
          if (agent && agent.serviceManagerId) {
            const res = await Api.getAgentInfo(agent.serviceManagerId)
            if (!res.data.disabled) {
              this.agent = res.data
            }
          }
        } catch (e) {
          console.log(e)
          this.show = false
        }
      }
      console.log(this.owner)
    }
  },
  mounted () {
    this.initData()
    this.listenScroll()
  }
}
</script>
<style lang="scss" scoped>
.follow-container {
  padding: 10px;
  position: fixed;
  bottom: 20px;
  width: 100%;
  box-sizing: border-box;

  .main {
    background: rgba(126, 126, 126, 0.3);
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px;
    border-radius: 10px;
    position: relative;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);

    .left {
      justify-content: flex-start;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 5px;
        background-size: contain;
      }
      .wrapper {
        margin-left: 10px;
        justify-content: space-around;
        align-items: flex-start;
        .name {
          color: rgb(219, 219, 219);
          font-size: 14px;
          font-weight: 800;
        }
        .info {
          color: rgb(219, 219, 219);
          font-size: 12px;
        }
      }
    }

    .right {
      .btn {
        background: rgb(35, 146, 85);
        padding: 13px 40px;
        font-size: 12px;
        border-radius: 5px;
        color: #fff;

        .wx-link {
          opacity: 0;
          // background: red;
          position: absolute;
          top: 0;
          left: 0;
          overflow: hidden;
          width: 100%;
          height: 80px;
        }
      }
      .followed {
        background: grey;
      }
    }
  }
}
</style>
